import copy from '../../demo/fixtures/w5/copy.json'
import { stationNow, useDemoStore } from '../../demo/store'
import { Button, Modal } from '../../ui'
import { ProcessSteps } from './ProcessSteps'
import { fillTemplate, type W5Live } from './live'
import { useProcessRun } from './useProcessRun'
import styles from './AnalysisPage.module.css'

interface SendReportDialogProps {
  open: boolean
  report: W5Live['report']
  onClose: () => void
  onDone: (message: string) => void
}

export function SendReportDialog({ open, report, onClose, onDone }: SendReportDialogProps) {
  const setSentAt = useDemoStore((state) => state.setW5ReportSentAt)
  const { visibleSteps, running, run } = useProcessRun()
  const recipients = report.recipients

  const send = async () => {
    const first = recipients[0] ?? { name: '—', email: '—' }
    const second = recipients[1] ?? { name: '—', email: '—' }
    const vars = { issue: report.issue, pages: report.pages, range: report.range, name1: first.name, email1: first.email, name2: second.name, email2: second.email }
    const completed = await run(copy.process.sendReport.map((step) => ({ label: fillTemplate(step.label, vars), detail: fillTemplate(step.detail, vars) })), copy.process)
    if (!completed) return
    setSentAt(stationNow())
    const { reportSentAt, reportSendCount } = useDemoStore.getState().w5
    const names = recipients.map((recipient) => recipient.name).join('、')
    onDone(reportSendCount === 1
      ? `${report.issue}已发送给 ${names}（${reportSentAt}）`
      : `${report.issue}已重新发送给 ${names} · 本期第 ${reportSendCount} 次（${reportSentAt}）`)
    onClose()
  }

  return (
    <Modal open={open} title={`发送${report.issue}周报`} hint={`${report.range} · 上次送达 ${report.reportSentAt ?? '尚未发送'}`} onClose={running ? () => undefined : onClose} footer={<><Button variant="ghost" disabled={running} onClick={onClose}>取消</Button><Button disabled={running} onClick={() => void send()}>{running ? '正在发送' : '确认发送'}</Button></>}>
      <div className={styles.recipientList}>
        <p>本期收件人 · {recipients.length} 位</p>
        {recipients.map((recipient) => <div key={recipient.email}><b>{recipient.name}</b><span>{recipient.email}</span></div>)}
      </div>
      {running ? <div className={styles.processSlot}><ProcessSteps steps={visibleSteps} /></div> : null}
    </Modal>
  )
}
